if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      } else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const formData = this.form ? new FormData(this.form) : new FormData();

      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      const productVariantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1', 10);

      const engravingInput = this.getEngravingInput();
      const engravingValue = engravingInput ? engravingInput.value.trim() : '';

      if (engravingValue) {
        this.addProductWithEngraving(formData, productVariantId, quantity, engravingValue);
      } else {
        this.addProductNormally(formData, productVariantId);
      }
    }

    getEngravingInput() {
      if (this.querySelector('[data-engraving-input]')) {
        return this.querySelector('[data-engraving-input]');
      }

      if (this.form && this.form.id) {
        const linkedInput = document.querySelector('[data-engraving-input][form="' + this.form.id + '"]');
        if (linkedInput) return linkedInput;
      }

      return document.querySelector('[data-engraving-input]');
    }

    addProductNormally(formData, productVariantId) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.handleCartResponse(response, productVariantId);
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('Une erreur est survenue. Merci de réessayer.');
        })
        .finally(() => {
          this.resetSubmitButton();
        });
    }

    addProductWithEngraving(formData, productVariantId, quantity, engravingValue) {
      const ENGRAVING_VARIANT_ID = 44458492231773;
      const engravingKey = `engraving-${productVariantId}-${Date.now()}-${Math.random().toString(36).slice(2)}`;

      const properties = {};

      for (const [key, value] of formData.entries()) {
        const propertyMatch = key.match(/^properties\[(.*)\]$/);

        if (propertyMatch && value) {
          properties[propertyMatch[1]] = value;
        }
      }

      properties['Ma personnalisation'] = engravingValue;
      properties['_engraving_key'] = engravingKey;

      const sections = this.cart
        ? this.cart.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      const body = {
        items: [
          {
            id: Number(productVariantId),
            quantity: quantity,
            properties: properties
          },
          {
            id: ENGRAVING_VARIANT_ID,
            quantity: quantity,
            properties: {
              '_engraving_key': engravingKey,
              '_Personnalisation associée': document.querySelector('.product__title')?.textContent?.trim() || 'Produit',
              '_Texte gravure': engravingValue
            }
          }
        ],
        sections: sections,
        sections_url: window.location.pathname
      };

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      };

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.handleCartResponse(response, productVariantId);
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('Erreur lors de l’ajout de la personnalisation. Merci de réessayer.');
        })
        .finally(() => {
          this.resetSubmitButton();
        });
    }

    handleCartResponse(response, productVariantId) {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: productVariantId,
          errors: response.description,
          message: response.message
        });

        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

        if (!soldOutMessage) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;

        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: productVariantId
        });
      }

      this.error = false;

      const quickAddModal = this.closest('quick-add-modal');

      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => {
            this.cart.renderContents(response);
          });
        }, { once: true });

        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    }

    resetSubmitButton() {
      this.submitButton.classList.remove('loading');

      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }

      if (!this.error) {
        this.submitButton.removeAttribute('aria-disabled');
      }

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}